import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import { Coordenada } from "src/app/models/entities/coordenada";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { Segmento } from "src/app/models/entities/segmento";
import {
  AbstractControl,
  Validators,
  FormControl,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Estado } from "src/app/models/entities/estado";
import { CatalogoService } from "src/app/services/catalogo.service";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { MapUtils } from "src/app/shared/utils/map-utils";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { take, toArray, concatMap, map, tap } from "rxjs/operators";
import { CapaService } from "src/app/services/capa.service";
import { SegmentoService } from "src/app/services/segmento.service";
import { LoaderService } from "src/app/services/loader.service";
import { AlertasService } from "src/app/services/alertas.service";
import { Capa } from "src/app/models/entities/capa";
import { GooglePolyline } from "src/app/models/google-polyline";
import { from } from "rxjs";
import { LevantamientoAvanceService } from "src/app/services/levantamiento-avance.service";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { MapsAPILoader } from "@agm/core";
import {
  InfoWindow,
  PolyMouseEvent,
} from "@agm/core/services/google-maps-types";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";

@Component({
  selector: "creacion-avances",
  templateUrl: "./creacion-avances.component.html",
  styleUrls: ["./creacion-avances.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreacionAvancesComponent implements OnInit {
  @ViewChild("modalCreacionAvance")
  public modalCreacionAvance: any;
  public modalActivoCreacionAvance: NgbModalRef;

  @Input("datosObra")
  public datosObra: LevantamientoSeleccionadoDTO;
  public map: any;
  public capaForm: FormGroup;
  public catEstados: Estado[];
  public catDireccionesAdjuntas: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catCapas: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";
  public readonly CAPA_META_ACTUAL: string = "1";
  public readonly CAPA_COMPLETADO: string = "2";
  public readonly CAPA_ESTRUCTURA: string = "5";
  public coordenadasMetaDisponibles: Coordenada[] = [];
  public componenteCargado: boolean = false;
  public usuarioEnSesion: UsuarioSesionDTO;
  public distanciaConRespectoProyecto: number = 0;
  public distanciaConRespectoCapa: number = 0;
  public coordenadaInicialNuevaCapa: Coordenada;
  public coordenadaFinalNuevaCapa: Coordenada;
  public coordenadaInicialProyecto: Coordenada;
  public coordenadaFinalProyecto: Coordenada;
  public coordenadaInicialMeta: Coordenada;
  public coordenadaFinalMeta: Coordenada;
  public capaMetaDisponible: CapaSegmentosDTO = null;
  public coordenadaInicialTrazo: Coordenada = null;
  public coordenadaFinalTrazo: Coordenada = null;
  public iconoCoordenadaDisponible: any = {
    url: "../../../../../assets/img/iconos/coordenada-disponible.png",
    scaledSize: {
      width: 5,
      height: 5,
    },
  };
  public anioActual = new Date().getFullYear();
  public idiomaCalendario: any;
  public iconoInicioFinCapa: any;
  public iconoInicioFinProyecto: any;
  public iconoNuevoTrazo: any;
  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto = false;
  public existeCapaMeta: boolean = false;
  public capaBackend: Capa;
  public segmentoBackend: Segmento;

  constructor(
    private catalogoService: CatalogoService,
    private mapUtils: MapUtils,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private loaderService: LoaderService,
    private alertasService: AlertasService,
    private levantamientoAvanceService: LevantamientoAvanceService,
    private facadeSesionService: FacadeSesionService,
    private dateUtils: DateUtils,
    private mapsAPILoader: MapsAPILoader,
    private cd: ChangeDetectorRef,
    private ngbModalService: NgbModal
  ) {
    this.idiomaCalendario = this.dateUtils.idiomaEspanol;
  }

  async ngOnInit() {
    this.facadeSesionService.usuarioEnSesionService
      .obtenerUsuario()
      .subscribe(
        (usuarioSesionDTO: UsuarioSesionDTO) =>
          (this.usuarioEnSesion = usuarioSesionDTO)
      );
    this.existeCapaMeta = this.buscarCapaMeta();
    if (this.existeCapaMeta) {
      await this.cargarCatalogos();
      await this.cargarIconos();
      this.cargarMarcadoresInicioFinMeta();
      this.cargarCoordenadasMetaDisponibles();
      this.componenteCargado = true;
    }
    this.cd.detectChanges();
  }

  public buscarCapaMeta(): boolean {
    let capaMeta: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_META_ACTUAL
    );
    return capaMeta ? true : false;
  }

  public cargarCoordenadasMetaDisponibles() {
    let coordenadasMeta: Coordenada[] = []; //Coordenadas capa meta
    let coordenadasCompletado: Coordenada[] = []; //Coordenadas capa completado
    let capaMeta: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_META_ACTUAL
    );
    let capaCompletado: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_COMPLETADO
    );

    if (capaCompletado) {
      capaCompletado.segmentos.forEach((segmento: Segmento) => {
        segmento.coordenadas.forEach(
          (coordenada: Coordenada, indice: number) => {
            coordenadasCompletado.push(coordenada);
          }
        );
      });
    }
    capaMeta.segmentos.forEach((segmento: Segmento) => {
      segmento.coordenadas.forEach((coordenada: Coordenada) => {
        coordenadasMeta.push(coordenada);
      });
    });

    /**
     * Lo que hace el algoritmo es lo siguiente:
     * Compara cada coordenada de la capa meta con con cada coordenada de la capa completado
     * 1 - Si la coordenada de la capa meta NO se encuentra en las coordenadas de la capa completado lo agrega al arreglo de coordenadas que el usuario podra seleccionar
     * 2 - Siempre debe haber una coordenada antes o una coordenada despues para que el usuario pueda seleccionar al menos dos puntos de la capa meta, sin importar que la coordenada se encuentre en
     * la capa de completados.
     * 3.- Cuando el segmento de la meta solo tiene dos coordenadas y estas pertenecen tambien a la capa de completado, se valida que los segmentos de completado tengan una key diferente.
     *
     */

    coordenadasMeta.forEach((meta: Coordenada, indice: number) => {
      this.coordenadasMetaDisponibles.push(meta);
    });
  }

  public validarConCoordAnterior(
    coordenadasMeta: Coordenada[],
    coordenadasCompletado: Coordenada[],
    indice: number
  ): boolean {
    return coordenadasCompletado.find(
      (completado: Coordenada) =>
        completado.latitud === coordenadasMeta[indice - 1].latitud &&
        completado.longitud === coordenadasMeta[indice - 1].longitud
    )
      ? false
      : true;
  }

  public validarConCoordPosterior(
    coordenadasMeta: Coordenada[],
    coordenadasCompletado: Coordenada[],
    indice: number
  ): boolean {
    return coordenadasCompletado.find(
      (completado: Coordenada) =>
        completado.latitud === coordenadasMeta[indice + 1].latitud &&
        completado.longitud === coordenadasMeta[indice + 1].longitud
    )
      ? false
      : true;
  }

  public validarDiferentesSegmentos(
    coordenadasMeta: Coordenada[],
    coordenadasCompletado: Coordenada[],
    indice: number
  ): boolean {
    let coordenadaEncontrada: Coordenada = coordenadasCompletado.find(
      (completado: Coordenada) =>
        completado.latitud === coordenadasMeta[indice].latitud &&
        completado.longitud === coordenadasMeta[indice].longitud
    );
    let coordenadaAnteriorEncontrada: Coordenada = coordenadasCompletado.find(
      (completado: Coordenada) =>
        completado.latitud === coordenadasMeta[indice - 1].latitud &&
        completado.longitud === coordenadasMeta[indice - 1].longitud
    );
    let coordenadaPosteriorEncontrada: Coordenada = coordenadasCompletado.find(
      (completado: Coordenada) =>
        completado.latitud === coordenadasMeta[indice + 1].latitud &&
        completado.longitud === coordenadasMeta[indice + 1].longitud
    );
    if (coordenadaAnteriorEncontrada && coordenadaPosteriorEncontrada) {
      if (
        coordenadaAnteriorEncontrada.keySegmento !==
          coordenadaPosteriorEncontrada.keySegmento &&
        coordenadaEncontrada
      ) {
        return true;
      }
    }
    return false;
  }

  public abrirModalCreacionAvance() {
    this.modalActivoCreacionAvance = this.ngbModalService.open(
      this.modalCreacionAvance,
      {
        centered: true,
        windowClass: "modal-confirmacion",
        backdrop: "static",
        keyboard: false,
      }
    );
    this.cd.detectChanges();
  }

  public async cargarIconos(): Promise<void> {
    await this.mapsAPILoader.load();
    this.iconoInicioFinCapa = {
      url: "../../../../../assets/img/iconos/marker-red.png",
      scaledSize: {
        width: 25,
        height: 25,
      },
      labelOrigin: new google.maps.Point(45, 30),
    };
    this.iconoInicioFinProyecto = {
      url: "../../../../../assets/img/iconos/marker-red.png",
      scaledSize: {
        width: 25,
        height: 25,
      },
      labelOrigin: new google.maps.Point(0, 0),
    };

    this.iconoNuevoTrazo = {
      url: "../../../../../assets/img/iconos/marker-capa-completado.png",
      scaledSize: {
        width: 25,
        height: 25,
      },
      labelOrigin: new google.maps.Point(45, 30),
    };
  }

  public cargarMarcadoresProyecto() {
    this.coordenadaInicialProyecto =
      this.mapUtils.obtenerCoordenadaInicialArregloPolylines(
        this.crearArregloPolylineProyecto()
      );
    this.coordenadaFinalProyecto =
      this.mapUtils.obtenerCoordenadaFinalArregloPolylines(
        this.crearArregloPolylineProyecto()
      );
  }

  public cargarMarcadoresInicioFinMeta() {
    this.coordenadaInicialMeta = {
      ...this.mapUtils.obtenerCoordenadaInicialArregloPolylines(
        this.crearArregloPolylineMeta()
      ),
    };
    this.coordenadaFinalMeta = {
      ...this.mapUtils.obtenerCoordenadaFinalArregloPolylines(
        this.crearArregloPolylineMeta()
      ),
    };
    //Se desfasa un poco la coordenada para que no cubra el icono de coordenada disponible.
    this.coordenadaInicialMeta.latitud += 0.00001;
    this.coordenadaFinalMeta.latitud += 0.00001;
  }

  public crearArregloPolylineProyecto(): Array<Coordenada[]> {
    let capaProyecto: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) =>
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO ||
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION
    );
    let segmentos: Array<Coordenada[]> = capaProyecto.segmentos.map(
      (segmento: Segmento) => segmento.coordenadas
    );
    return segmentos;
  }
  public crearArregloPolylineMeta(): Array<Coordenada[]> {
    let capaMeta: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_META_ACTUAL
    );
    let segmentos: Array<Coordenada[]> = capaMeta.segmentos.map(
      (segmento: Segmento) => segmento.coordenadas
    );
    return segmentos;
  }

  public markerMouseOver(event: PolyMouseEvent, infoWindow: InfoWindow) {
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    this.infoWindowAbierto = true;
  }

  public obtenerKeyColorPorKeyCapa(keyCapa: string): string {
    /**No siempre coincidiran el cat color con el cat capa, por eso se crea esta funcion */
    if (keyCapa === "1") {
      return "1";
    }
    if (keyCapa === "2") {
      return "2";
    }
    if (keyCapa === "3") {
      return "3";
    }
    if (keyCapa === "5") {
      return "5";
    }
  }

  public async cargarCatalogos(): Promise<void> {
    this.catEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoObra = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoLevantamiento = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS)
      .pipe(take(1))
      .toPromise();
    this.catColores = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.catCapas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS)
      .pipe(take(1))
      .toPromise();
  }

  public obtenerHexColorCapa(key: string): string {
    return this.catColores.find((c: ElementoCatalogo) => c.key === key).nombre;
  }

  public mapReady(event: any): void {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.obtenerCoordenadasMetaActual()
    );
  }

  public centrarMeta() {
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.obtenerCoordenadasMetaActual()
    );
  }

  public empezarTrazo(coordenadaSeleccionada: Coordenada) {
    this.coordenadaInicialTrazo = { ...coordenadaSeleccionada };
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.cd.detectChanges();
  }

  public finalizarTrazo(coordenadaSeleccionada: Coordenada): void {
    this.coordenadaFinalTrazo = { ...coordenadaSeleccionada };
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.abrirModalCreacionAvance();
    this.cd.detectChanges();
  }

  public limpiarTrazo(): void {
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
      this.infoWindowActual = null;
      this.infoWindowAbierto = false;
    }
    this.coordenadaInicialTrazo = null;
    this.coordenadaFinalTrazo = null;
    this.cd.detectChanges();
  }

  public limpiarCoordenadaFinalTrazo() {
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
      this.infoWindowActual = null;
      this.infoWindowAbierto = false;
    }
    this.coordenadaFinalTrazo = null;
    this.modalActivoCreacionAvance.close();
  }

  public obtenerCoordenadasMetaActual() {
    let capaMetaActual: CapaSegmentosDTO = this.obtenerCapaMetaActual();
    let segmentos: Array<Coordenada[]> = new Array<Coordenada[]>();
    capaMetaActual.segmentos.forEach((segmento: Segmento) => {
      segmentos.push(segmento.coordenadas);
    });
    return segmentos.map((segmento: Coordenada[]) =>
      this.crearPolyline(segmento)
    );
  }

  public obtenerCapaMetaActual() {
    return this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_META_ACTUAL
    );
  }

  public obtenerCoordenadasProyecto(): GooglePolyline[] {
    let capaProyecto: CapaSegmentosDTO = this.obtenerCapaProyecto();
    let segmentos: Array<Coordenada[]> = new Array<Coordenada[]>();
    capaProyecto.segmentos.forEach((segmento: Segmento) => {
      segmentos.push(segmento.coordenadas);
    });
    return segmentos.map((segmento: Coordenada[]) =>
      this.crearPolyline(segmento)
    );
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map((p) => ({
        lat: p.latitud,
        lng: p.longitud,
      })),
    };
  }

  public crearArregloPolylines(coordenadasElemento: Array<Coordenada[]>): any {
    return coordenadasElemento.map((coordenadas: Coordenada[]) =>
      this.crearPolyline(coordenadas)
    );
  }

  public obtenerCapaProyecto(): CapaSegmentosDTO {
    return this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) =>
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO ||
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION
    );
  }

  public async crearAvance() {
    try {
      this.loaderService.activarLoaderScreen();
      let fechaActual: number = new Date().getTime();
      let capa: any = await this.crearCapa(fechaActual);
      // await this.guardarCapaBackend(capa.key, this.capaBackend).then(
      //   () => {
      //     console.log("Capa guardada correctamente en el servidor!");
      //   },
      //   (err) =>
      //     console.log(
      //       "Hubo un error al intentar guardar la capa en el servidor!"
      //     )
      // );
      await this.crearSegmento(
        capa.key,
        this.obtenerCoordenadasSeleccionadas(),
        fechaActual
      );
      // await this.guardarSegmentoBackend(
      //   capa.key,
      //   this.obtenerCoordenadasSeleccionadas(),
      //   fechaActual
      // ).then(
      //   () => {
      //     console.log("Segmento guardado correctamente en el servidor!");
      //   },
      //   (err) =>
      //     console.log(
      //       "Hubo un error al intentar guardar el segmento en servidor!"
      //     )
      // );
      this.alertasService.mostrarAlerta(
        "success",
        "Se ha creado el avance exitosamente.",
        "En la pestaña de estatus podrá visualizar el avance creado para la capa de completado.",
        10000
      );
      await this.levantamientoAvanceService.actualizarObra(this.datosObra);
      this.limpiarTrazo();
    } catch (err) {
      this.alertasService.mostrarAlerta(
        "error",
        "Ocurrió un error al intentar crear el avance.",
        err
      );
    } finally {
      this.loaderService.desactivarLoaderScreen();
      this.modalActivoCreacionAvance.close();
      this.cd.detectChanges();
    }
  }

  public async crearCapa(fechaActual: number): Promise<any> {
    let capaCompletado: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_COMPLETADO
    );
    if (capaCompletado) {
      return { key: capaCompletado.capa.key };
    } else {
      let capa: Capa = {
        keyLevantamientoObra: this.datosObra.levObra.key,
        keyCatCapa: this.CAPA_COMPLETADO,
        fechaCreacion: fechaActual,
        fechaActualizacion: fechaActual,
        keyUsuarioCreacion: this.usuarioEnSesion.usuario.key,
      };
      console.log(capa);
      this.capaBackend = capa;
      return this.capaService.save(capa);
    }
  }

  guardarCapaBackend(key, capa) {
    const capaBackend: Capa = {
      key: key,
      ...capa,
    };
    console.log(capaBackend);
    return this.capaService.save2(capaBackend);
  }

  public async crearSegmento(
    keyCapa: string,
    coordenadas: Coordenada[],
    fechaActual: number
  ): Promise<any> {
    let segmento: Segmento = {
      coordenadas,
      fechaActualizacion: fechaActual,
      fechaCreacion: fechaActual,
      keyCatColor: this.obtenerKeyColorPorKeyCapa(this.CAPA_COMPLETADO),
      keyUsuarioCreacion: this.usuarioEnSesion.usuario.key,
      keyCapa: keyCapa,
      longitud: await this.mapUtils.obtenerLongitudSegmento(coordenadas),
    };
    return this.segmentoService.save(segmento);
  }

  async guardarSegmentoBackend(
    keyCapa: string,
    coordenadas: Coordenada[],
    fechaActual: number
  ) {
    let segmento: Segmento = {
      keyCapa,
      keyCatColor: this.obtenerKeyColorPorKeyCapa(
        this.capaForm.get("keyCapa").value
      ),
      fechaCreacion: fechaActual,
      fechaActualizacion: fechaActual,
      fechaRegistro:
        this.capaForm.get("keyCapa").value === this.CAPA_COMPLETADO
          ? (this.capaForm.get("fechaRegistro").value as Date).getTime()
          : fechaActual,
      keyUsuarioCreacion: this.usuarioEnSesion.usuario.key,
      coordenadas,
      longitud: await this.mapUtils.obtenerLongitudSegmento(coordenadas),
    };
    console.log(segmento);
    return this.segmentoService.save2(segmento);
  }

  public obtenerCoordenadasSeleccionadas(): Coordenada[] {
    let coordenadasCapaMeta: Coordenada[] = [];
    let capaMeta: CapaSegmentosDTO = this.datosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) => capa.capa.keyCatCapa === this.CAPA_META_ACTUAL
    );
    capaMeta.segmentos.forEach((segmento: Segmento) => {
      segmento.coordenadas.forEach((coordenada: Coordenada) => {
        coordenadasCapaMeta.push(coordenada);
      });
    });
    let indiceInicio: number = coordenadasCapaMeta.findIndex(
      (c: Coordenada) =>
        c.latitud === this.coordenadaInicialTrazo.latitud &&
        c.longitud === this.coordenadaInicialTrazo.longitud
    );
    let indiceFin: number = coordenadasCapaMeta.findIndex(
      (c: Coordenada) =>
        c.latitud === this.coordenadaFinalTrazo.latitud &&
        c.longitud === this.coordenadaFinalTrazo.longitud
    );
    let coordenadas: Coordenada[] = [];
    if (indiceInicio < indiceFin) {
      for (let indice = indiceInicio; indice <= indiceFin; indice++) {
        coordenadas.push(coordenadasCapaMeta[indice]);
      }
    } else {
      for (let indice = indiceFin; indice <= indiceInicio; indice++) {
        coordenadas.push(coordenadasCapaMeta[indice]);
      }
    }
    return coordenadas;
  }
}
